/**
 * Copyright ©2025 Drivepoint
 */

import {Store} from "@bainbridge-growth/node-frontend";
import WebAppServerClient from "../clients/WebAppServerClient";
import State from "../state/State";
import {StateEvent} from "../state/StateEvent";

export default class ActiveUsersAndCompaniesStore extends Store {

  private _company?: any;

  init(): void {
    this.loading = true;
    State.register("company", (event: StateEvent) => {
      this.value = [];
      this._company = event.value;
      this.refresh();
    });
  }

  async refresh(): Promise<void> {
    return this.action(async () => {
      if (!this._company) { return; }
      this.value = await WebAppServerClient.request(`/api/company/${this._company?.id}/user/active`, "GET");
    });
  }

}
